import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  icon?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看更多",
  icon,
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6 md:mb-8">
      <div>
        <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 flex items-center gap-2.5">
          {icon && (
            <span className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center">
              <i className={`${icon} text-primary-600 text-lg`} />
            </span>
          )}
          {title}
        </h2>
        {subtitle && <p className="text-sm text-foreground-500 mt-2">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 text-sm text-primary-600 hover:text-primary-700 flex items-center gap-1 whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}